import PropTypes from 'prop-types';
import React, {useState, useEffect} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {getMembershipFees, putMembershipFeeRemark} from "../../../lib/api_membership";
import {Table, Popover, notification, Button, Modal, Input, message} from 'antd';
import moment from 'moment';
import Box from '../../../components/box/index';
import {EditOutlined, FullscreenOutlined} from '@ant-design/icons';


const {Column} = Table;

const DataTable = ({list, students, scroll, onRefresh}) => {
    const [editingId, setEditingId] = useState(null);
    const [editingRemark, setEditingRemark] = useState('');

    const startEdit = (record) => {
        setEditingId(record.id);
        setEditingRemark(record.remark || '');
    };

    const saveRemark = () => {
        if (!editingId) return;
        putMembershipFeeRemark(editingId, editingRemark)
            .then(res => {
                if (res.code === 0) {
                    message.success('备注修改成功');
                    setEditingId(null);
                    if (onRefresh) onRefresh();
                } else {
                    message.error(res.message || '修改失败');
                }
            })
            .catch(() => {
                message.error('修改失败');
            });
    };

    const cancelEdit = () => {
        setEditingId(null);
        setEditingRemark('');
    };

    return (
        <Table
            size={"small"}
            dataSource={list}
            rowKey={"id"}
            pagination={false}
        >
            <Column
                title="时间"
                dataIndex="createdAt"
                key="时间"
                width={180}
                render={(time) => moment(time).format("YYYY-MM-DD ddd HH:mm")}
            />
            <Column
                title="金额"
                dataIndex="fee"
                key="金额"
                align="right"
            />
            <Column
                title="赠送"
                dataIndex="is_gift"
                key="赠送"
                width={60}
                render={(is_gift) => is_gift === 0 ? "否" : "是"}
            />
            <Column
                title="备注"
                dataIndex="remark"
                key="备注"
                render={(remark, record) => {
                    if (editingId === record.id) {
                        return (
                            <Input
                                size="small"
                                value={editingRemark}
                                onChange={e => setEditingRemark(e.target.value)}
                                onPressEnter={saveRemark}
                                onBlur={saveRemark}
                                style={{width: 160}}
                                autoFocus
                            />
                        );
                    }
                    return (
                        <span
                            onClick={() => startEdit(record)}
                            style={{cursor: 'pointer', minWidth: 60, display: 'inline-block'}}
                            title="点击修改备注"
                        >
                            <EditOutlined style={{color: '#999', marginRight: 4, fontSize: 12}} />
                            {remark || <span style={{color: '#bbb'}}>点击添加备注</span>}
                        </span>
                    );
                }}
            />
            <Column
                title="会员"
                dataIndex="user_id"
                key="会员"
                render={(user_id) => {
                    let student = students.find(_ => _.id === user_id);
                    if (student) {
                        return <Link to={`/member/members/${student.id}`}>{student.nick_name}</Link>;
                    } else {
                        return null;
                    }
                }}
            />
        </Table>
    )
}

const MembershipFee = ({id, students}) => {
    const [list, setList] = useState([]);
    const [more, setmore] = useState(false);

    const fetchData = () => {
        getMembershipFees(id)
            .then(res => {
                if (res.code === 0) {
                    setList(res.data);
                }
            })
    };

    useEffect(fetchData, []);

    return (
        <Box title={`教练费记录(${list.length}条)`} style={{marginTop: 10}} extra={[
            <Button type="link" onClick={() => setmore(true)}>查看更多</Button>
        ]}>
            <DataTable list={list.slice(0, 5)} students={students} onRefresh={fetchData}/>
            <Modal
                visible={more}
                title={`教练费记录(${list.length}条)`}
                footer={false}
                onCancel={() => setmore(false)}
                width={700}
            >
                <DataTable list={list} students={students} onRefresh={fetchData}/>
            </Modal>
        </Box>
    )
};


MembershipFee.propTypes = {
    id: PropTypes.number.isRequired,
};


const mapStateToProps = state => ({
    students: state.students
});

const mapDispatchToProps = dispatch => ({});


export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(MembershipFee));
